export default __webpack_public_path__ + "static/media/inner-course-symb.96977085.png";